// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u0-2";
export var chatLink = "_u0-0";
export var chatText = "_u0-1";